import { render, staticRenderFns } from "./LeadHeader.vue?vue&type=template&id=366916c4"
import script from "./LeadHeader.vue?vue&type=script&lang=js"
export * from "./LeadHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports